import React, { Component } from 'react';
import MaterialIcon from 'material-icons-react';
import classNames from 'classnames';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import { TextField, Typography, Input, Hidden } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import strings from './components/language/language';

const styles = theme => ({
  margin: {
    // margin: theme.spacing.unit,
    // marginRight: "auto",
    // marginLeft: "auto",
    // maxWidth:"223px;", //354px
    marginTop: '11px',

    // minWidth:"323px",
    //  paddingTop:"3px",
    paddingBottom: '3px',
    // paddingLeft:"10px",
    // paddingRight:"10px",

    ':focus': {
      background: 'black'
    }
  }
});

class SearchBar extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    query: '',
    text: null
  };

  clear = () => {
    this.setState({
      text: ''
    });
  };

  queryChange = evt => {
    // console.log('TESTAWY' + evt.target.value);
    this.setState({ query: evt.target.value });
  };
  render() {
    const { classes } = this.props;
    return (
      <div className='desktop-searchbar-facebook'>
        {/* <Hidden mdUp> */}
        <TextField
          //onClick={this.expand}

          // fullWidth
          variant='outlined'
          className={classNames(classes.margin, 'text-field')}
          placeholder={strings.search_for_items}
          style={{ borderRadius: 19 }}
          value={this.props.query}
          onChange={this.props.queryChange}
          id='input-with-icon-textfield'
          InputProps={{
            variant: 'outlined',
            disableUnderline: true,
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon
                  style={{ position: 'relative', left: '8px', top: 2 }}
                />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment variant='filled' position='end'>
                <CloseIcon
                  style={{
                    fontSize: '17',
                    position: 'relative',
                    right: '10px',
                    cursor: 'pointer',
                    top: 1
                  }}
                  onClick={this.props.clear}
                />
              </InputAdornment>
            )
          }}
        />
        {/* </Hidden> */}
        {/* <Hidden smDown>
          <TextField
            //onClick={this.expand}

            // fullWidth
            type='search'
            variant='outlined'
            className={classNames(
              classes.margin,
              classes.textRoot,
            )}
            placeholder={strings.search_for_items}
            value={this.props.query}
            onChange={this.props.queryChange}
            id='input-with-icon-textfield'
            InputProps={{
              //variant: "outlined",
              disableUnderline: true,
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchIcon
                    style={{
                      position: 'relative',
                      left: '8px',
                      color: '#A9A9A9'
                    }}
                  />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment variant='filled' position='end'>
                  <CloseIcon
                    style={{
                      fontSize: '17',
                      position: 'relative',
                      right: '4px'
                    }}
                    onClick={this.props.clear}
                  />
                </InputAdornment>
              )
            }}
          />
        </Hidden> */}
      </div>
    );
  }
}
export default withStyles(styles)(SearchBar);



// WEBPACK FOOTER //
// ./src/SearchBar.js